<template>
  <DeleteConfirm
      itemKey="TicketCommission"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import TicketCommissions from '@/services/ticket-commissions'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return TicketCommissions
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť províziu z ' + this.$moment(Item.workedAt).format('DD.MM.YYYY') + ' od ' + Item.User.name
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť províziu z ' + this.$moment(Item.workedAt).format('DD.MM.YYYY') + ' od ' + Item.User.name + '?'
      },
      deleteData() {
        return TicketCommissions
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
